import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IEmailTemplateParameter } from '../interfaces/email-template';
import { IEmailTemplateParameterFilter } from '../interfaces/email-template-filter';
import { EditService } from './edit.service';

import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class EmailTemplateParameterService extends EditService<
  IEmailTemplateParameter,
  IEmailTemplateParameterFilter
> {
  url = '/api/emailtemplateparameters';
  entityTitle = 'EmailTemplateParameter';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }
}
